import styled from "styled-components";

export const Container = styled.div`
  text-align: center;
  & > * {
    margin-bottom: 20px;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  & > * {
  }
`;
